import React, { useState } from "react";
import AssignUser from "./assignUser";
import AllUsers from "./allUsers";

const MainPage = () => {
  const [selectedOption, setSelectedOption] = useState("new");

  return (
    <div style={{ padding: "0px" }}>
      <div className="mainpage-radio-container" style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px", justifyContent: "flex-start" }}>
        <span className="mainpage-radio-label-span" style={{ display: "inline-flex", alignItems: "center", gap: "4px", cursor: "pointer", fontSize: "13px", margin: "0px", padding: "0px" }}>
          <input
            type="radio"
            name="teacherType"
            value="new"
            checked={selectedOption === "new"}
            onChange={(e) => setSelectedOption(e.target.value)}
            className="mainpage-radio-input-element"
            style={{ cursor: "pointer", margin: "0px", width: "auto", height: "auto", display: "inline-block" }}
          />
          New
        </span>
        <span className="mainpage-radio-label-span" style={{ display: "inline-flex", alignItems: "center", gap: "4px", cursor: "pointer", fontSize: "13px", margin: "0px", padding: "0px" }}>
          <input
            type="radio"
            name="teacherType"
            value="existing"
            checked={selectedOption === "existing"}
            onChange={(e) => setSelectedOption(e.target.value)}
            className="mainpage-radio-input-element"
            style={{ cursor: "pointer", margin: "0px", width: "auto", height: "auto", display: "inline-block" }}
          />
          Existing
        </span>
      </div>

      <div style={{ marginTop: "10px" }}>
        {selectedOption === "new" ? <AssignUser /> : <AllUsers />}
       
      </div>
    </div>
  );
};

export default MainPage;
